import { History, Loader2, Printer } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { fmtDateTime } from "@/lib/datetime";

// Historial · Reimpresión de comprobantes — presentacional.
export const HistorialDialog = ({ histOpen, setHistOpen, histLoading, histList, paperWidth, setPaperWidth, reimprimirTicket }) => (
  <Dialog open={histOpen} onOpenChange={setHistOpen}>
    <DialogContent className="rounded-none border-white/20 bg-[#0A0A0A] text-white sm:max-w-lg max-h-[90dvh] overflow-y-auto overflow-x-hidden" data-testid="historial-dialog">
      <DialogHeader>
        <DialogTitle className="font-display font-black text-white flex items-center gap-2"><History className="h-5 w-5 text-[#FFCC00]" /> Historial · Reimprimir</DialogTitle>
        <DialogDescription className="text-white/50">Previsualiza o reimprime el comprobante de un cobro anterior (calibración de impresora).</DialogDescription>
      </DialogHeader>
      <div className="flex items-center justify-end gap-2 pb-1">
        <span className="text-[10px] uppercase tracking-wider font-bold text-white/40">Ancho</span>
        <div className="flex items-center border border-white/15">
          <button onClick={() => setPaperWidth(58)} data-testid="hist-paper-58"
            className={`h-9 px-3 text-xs font-bold uppercase tracking-wider transition-colors duration-200 ${paperWidth === 58 ? "bg-[#FFCC00] text-[#0A0A0A]" : "text-white/50 hover:text-white"}`}>58mm</button>
          <button onClick={() => setPaperWidth(80)} data-testid="hist-paper-80"
            className={`h-9 px-3 text-xs font-bold uppercase tracking-wider transition-colors duration-200 ${paperWidth === 80 ? "bg-[#FFCC00] text-[#0A0A0A]" : "text-white/50 hover:text-white"}`}>80mm</button>
        </div>
      </div>
      <div className="max-h-[50vh] overflow-y-auto divide-y divide-white/10" data-testid="historial-list">
        {histLoading ? (
          <div className="py-10 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-[#FFCC00]" /></div>
        ) : histList.length === 0 ? (
          <div className="py-10 text-center text-white/40 text-sm" data-testid="historial-empty">Sin cobros registrados aún.</div>
        ) : histList.map((t) => (
          <div key={t.id_ticket} className="flex items-center justify-between py-3 gap-3" data-testid={`hist-row-${t.folio_impreso}`}>
            <div className="min-w-0">
              <p className="font-mono text-sm text-white truncate">{t.folio_impreso}</p>
              <p className="text-[11px] text-white/50">{t.metodo_pago || "—"} · {t.estancia_texto} · {t.fecha_salida ? fmtDateTime(t.fecha_salida) : ""}</p>
            </div>
            <div className="flex items-center gap-3 shrink-0">
              <span className="font-display font-black text-[#FFCC00]">${Number(t.total_pagado).toFixed(2)}</span>
              <button onClick={() => reimprimirTicket(t, paperWidth)} data-testid={`hist-reimprimir-${t.folio_impreso}`}
                className="btn-hard h-10 px-3 bg-white/5 border border-white/20 hover:border-[#FFCC00] text-white text-xs font-bold uppercase tracking-wider flex items-center gap-2">
                <Printer className="h-4 w-4" /> Reimprimir
              </button>
            </div>
          </div>
        ))}
      </div>
    </DialogContent>
  </Dialog>
);

export default HistorialDialog;
